import React from "react";
import "./sidebar-sub-title.css";

interface SidebarSubTitleProps {
	children: React.ReactNode;
	icon?: React.ReactNode;
	id?: string;
	className?: string;
	style?: React.CSSProperties;
}

export function SidebarSubTitle({ children, icon, id, className, style }: SidebarSubTitleProps) {
	const combinedClassName = `sidebar-sub-title ${className || ""}`;

	return (
		<div className={combinedClassName} id={id} style={style}>
			{icon && <span className="sidebar-sub-title__icon">{icon}</span>}
			<span className="sidebar-sub-title__text">{children}</span>
		</div>
	);
}
